import { create } from 'zustand';
import { Optional, RootOutcome, RootOutcomes } from 'src/types';
import { deleteKey } from 'src/utils';

interface RootOutcomesState {
  rootOutcomes: RootOutcomes;
  getRootOutcome: (outcomeId: string) => Optional<RootOutcome>;
  setRootOutcome: (outcomeId: string, rootOutcome: Optional<RootOutcome>) => void;
  removeRootOutcome: (outcomeId: string) => void;
  clearRootOutcomes: () => void;
}

export const useRootOutcomesStore = create<RootOutcomesState>((set, get) => ({
  rootOutcomes: {},

  getRootOutcome: (outcomeId: string) => {
    return get().rootOutcomes[outcomeId];
  },

  setRootOutcome: (outcomeId: string, rootOutcome: Optional<RootOutcome>) => {
    set((state) => ({
      rootOutcomes: {
        ...state.rootOutcomes,
        [outcomeId]: rootOutcome,
      },
    }));
  },

  removeRootOutcome: (outcomeId: string) => {
    set((state) => ({
      rootOutcomes: deleteKey(state.rootOutcomes, outcomeId),
    }));
  },

  clearRootOutcomes: () => {
    set({ rootOutcomes: {} });
  },
}));